// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import Toastify from "toastify-js"

// Import application styles compiled by webpacker
import "../styles/auth.css"
import "../styles/theme.css"
import "../styles/sankro-home.css"

// Make images in app/javascript/images available to the webpack manifest
// so helpers like image_pack_tag can resolve them.
const images = require.context('../images', true)
const imagePath = (name) => images(name, true)
window.imagePath = imagePath

// Ensure these image assets are explicitly included in the webpack manifest
require('../images/bag.png')
require('../images/keys.png')

Rails.start()
Turbolinks.start()
ActiveStorage.start()

document.addEventListener('turbolinks:load', function() {
  document.querySelectorAll('.alert.tostify').forEach(function(elem){
    elem.style.display ='none';
    // Display alert with Toastify
    Toastify({
      text: elem.textContent.trim(),
      duration: 4000,
      gravity: "top",
      position: "center",
      // backgroundColor: elem.classList.contains('alert-success') ? "#51b96a" : "#e55353"
      style: {
        background: "linear-gradient(to right, #00b09b, #96c93d)",
      }
    }).showToast();
    // elem.style.transition = 'opacity 0.6s';
    // elem.style.opacity = '0';
    // setTimeout(function() { 
    //   if (elem.parentNode) elem.parentNode.removeChild(elem); 
    // }, 600);
  });

  const searchbarFormContainer = document.getElementById("searchbar-form-container");
    const toggleSearchBtn = document.getElementById("toggle-searchbar-btn");
    const toolbarControls = document.getElementById("toolbar-controls");
    const closeBtn = document.getElementById("close-searchbar-btn");
    let searchVisible = false;

    // Position searchbar overlay centered (fixed for full width header)
    function showSearchbar() {
      searchbarFormContainer.style.display = 'block';
      toolbarControls.style.display = 'none';
      toggleSearchBtn.style.display = 'none';
      searchVisible = true;
      // Focus input after a short delay
      setTimeout(() => {
        const input = searchbarFormContainer.querySelector("input[name='uuid']");
        if (input) input.focus();
      }, 120);
    }
    function hideSearchbar() {
      searchbarFormContainer.style.display = 'none';
      toolbarControls.style.display = '';
      toggleSearchBtn.style.display = '';
      searchVisible = false;
    }

    toggleSearchBtn && toggleSearchBtn.addEventListener('click', function(e) {
      showSearchbar();
    });

    closeBtn && closeBtn.addEventListener('click', function() {
      hideSearchbar();
    });

    // Also hide on submitting the search form (optional UX)
    const searchForm = searchbarFormContainer && searchbarFormContainer.querySelector("form");
    if (searchForm) {
      searchForm.addEventListener('submit', function() {
        setTimeout(() => { hideSearchbar(); }, 100);
      });
    }

    // ESC closes searchbar
    document.addEventListener('keydown', function(e) {
      if (searchVisible && (e.key === 'Escape' || e.key === 'Esc')) {
        hideSearchbar();
      }
    });

    // Ensure items-table-view doesn't exceed visible window width
    function setTableViewMaxWidth() {
      var tbl = document.getElementById('table-view');
      // console.log("resizing", tbl);   // Optional debug
      if (!tbl) return;
      // Calculate available width inside .admin-main or window
      if(tbl.dataset.hasViewToggle === 'true'){
        tbl.style.display = "none";
      }
      var main = document.querySelector('.admin-main');
      var padding = 10; // some safe margin/padding
      var w = (main ? main.clientWidth : window.innerWidth) - padding;
      if (w < 250) w = 250; // minimum sensible width
      tbl.style.maxWidth = w + "px";
      tbl.style.overflowX = "auto";
      tbl.style.margin = "0 auto";
      if(tbl.dataset.hasViewToggle !== 'true') tbl.style.display = "block";
      var prefView = localStorage.getItem('item_view') || 'card';
      if (typeof setItemView !== 'undefined' && tbl.dataset.hasViewToggle=='true') setItemView(prefView);
    }
    setTableViewMaxWidth();
    // Use both window and document and debounce for better reliability
    var resizeTimeout;
    function debouncedResize() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(setTableViewMaxWidth, 60);
    }
    window.addEventListener('resize', debouncedResize);
    document.addEventListener('resize', debouncedResize);

    // Find all elements with class .browser-time and data-utc attribute
    document.querySelectorAll('.browser-time[data-utc]').forEach(function(el) {
      var utcIso = el.dataset.utc;
      if (!utcIso) return;
      try {
        // Parse as UTC and convert to local
        var date = new Date(utcIso);
        // Check for valid date
        if (!isNaN(date.getTime())) {
          // Format using user's locale, default to long format, fallback to iso
          var format = el.dataset.localtimeFormat || "long";
          let formatted;
          switch (format) {
            case 'short':
              formatted = date.toLocaleString(undefined, { year: '2-digit', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' });
              break;
            case 'time':
              formatted = date.toLocaleTimeString();
              break;
            case 'date':
              formatted = date.toLocaleDateString();
              break;
            case 'long':
            default:
              // 'long' shows full date/time in local
              formatted = date.toLocaleString();
          }
          el.textContent = formatted;
          // Optionally, set the title as ISO/long
          el.title = date.toString();
          // Fallback: hide sibling <noscript> element if it exists
          var next = el.nextElementSibling;
          if (next && next.tagName === "NOSCRIPT") next.style.display = "none";
        }
      } catch (err) {
        // Fail silently; leave fallback text
      }
    });
});
window.Toastify = Toastify;